import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var AdminDesignationListRes;
export const AdminDesignationListTodo = createAsyncThunk('AdminDesignationList', async (data) => {


    try {
        const res = await axios({
            method: "get",
            url: process.env.REACT_APP_API_URL + 'admin/designation_admin',
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') },

        })
        return AdminDesignationListRes = res.data

    } catch (error) {
        return AdminDesignationListRes = error.response.data
    }
});

const AdminDesignationListSlice = createSlice({
    name: 'AdminDesignationList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(AdminDesignationListTodo.fulfilled, (state, action) => {
            state.data = action.payload;
            // console.log('userList', state.data)
        });
        builder.addCase(AdminDesignationListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default AdminDesignationListSlice.reducer; 